import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStarOutline } from '@fortawesome/pro-regular-svg-icons';

const StarringInstructions = () => {
  return (
    <div className="flex gap-2 items-center leading-4 text-sm my-4">
      <FontAwesomeIcon
        icon={faStarOutline}
        className="text-3xl text-gray-500"
      />
      <span>
        Star one photo to use it as the primary photo on all relevant search
        results pages and your Facility page.
      </span>
    </div>
  );
};

export { StarringInstructions };
